import type { SVGProps } from 'react'
const SvgSyQuant = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 141.7 141.7" width={24} height={24} {...props}>
		<path d="m36.5 11.2 34.6 40.5 23.2-13.6S66.3.6 58.8 3.3c-7 2.7-22.3 7.9-22.3 7.9m58.7 26.9s5.3-9.2 7.9-21.6c0 0 26.3 10.6 16.2 37z" />
		<path d="m119.2 53.5 2.2 27.7 10.1-1.3s2.6-.9 2.2-5.7c-.4-5.3-1.3-16.3-1.3-16.3s.4-2.6-5.7-3.5c-7.5-1.4-7.5-.9-7.5-.9" />
		<path d="m121.4 81.2-20.1 16.3 9.2 18s2.2 7 8.7-.9c6.1-7.9 8.7-9.2 8.3-14.1-.4-4.8-1.7-16.3-6.1-19.4zm-20.6 16.3L73.2 85.2l-24.1 48.9s-1.8 3.5 4.4 4c6.1.9 16.2 3.1 21.4-2.2 5.3-4.8 25.8-38.3 25.8-38.3zM73.3 84.7l-2.6-32.6-59.5 4s-3.5.4-3.1 7c.4 8.8 1.3 18.5 1.3 18.5s-.4 4 7.4 4.4c7.9.4 55.6.4 56.5-1.3" />
	</svg>
)
export default SvgSyQuant
